"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const Row_1 = require("../components/Row");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/");
const reducers_1 = require("../../../reducers");
const DeviceListSelectorModal_1 = require("./DeviceListSelectorModal");
const LoadingIndicator_1 = require("../../home/LoadingIndicator");
const MobilePopover_1 = require("../components/MobilePopover");
class DeviceListSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.updatePopoverVisibility = this.updatePopoverVisibility.bind(this);
    }
    updatePopoverVisibility() {
        const { activePopover, updateActivePopover, device } = this.props;
        if (activePopover === 'identifier-selector') {
            actions_1.closePopoverModalForm();
            setTimeout(() => {
                updateActivePopover('');
            }, device === 'Mobile' ? 500 : 0);
            return;
        }
        updateActivePopover('identifier-selector');
    }
    renderIdentifierSelector() {
        const { segment: { keyPath }, device, activePopover, isPopoverModalFormOpen, } = this.props;
        return (React.createElement(Row_1.default, { onClick: this.updatePopoverVisibility },
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(src_1.Text, { text: "Identifier", label: true, size: "small" }),
                React.createElement(src_1.Text, { text: keyPath, size: "large", textStyle: { color: src_1.charcoal } })),
            device !== 'Mobile' ? (React.createElement(src_1.PopoverContainer, { id: "identifier-selector-popover", popoverProps: {
                    placement: 'left',
                    device: device,
                    navBarProperties: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.updatePopoverVisibility,
                        title: 'Identifiers',
                    },
                }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: this.updatePopoverVisibility, showPopover: activePopover === 'identifier-selector' },
                device === 'Desktop' ? (React.createElement(src_1.Button, { text: "Change", type: "regular", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "identifier-condition-selector" })) : (React.createElement(src_1.ChangeIcon, { fill: src_1.titanium })),
                React.createElement("div", { style: {
                        width: 384,
                        display: 'flex',
                        flexDirection: 'column',
                    } }, this.renderKeyPaths()))) : (React.createElement(React.Fragment, null, activePopover === 'identifier-selector' &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.updatePopoverVisibility,
                        title: 'Identifiers',
                    } },
                    React.createElement("div", { style: {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        } }, this.renderKeyPaths())), document.getElementById('mainModalLeft'))))));
    }
    renderKeyPaths() {
        const { segment: { deviceList: { id, name, size, createdAt }, keyPath, }, deviceListKeyPaths, device, updateSegmentDeviceList, updateSegmentDeviceListKeyPath, } = this.props;
        return (React.createElement("div", { style: { flex: '1 1 auto', overflowY: 'scroll' } },
            React.createElement(src_1.SelectableList, { device: device }, deviceListKeyPaths.map((keyPathOption, index) => {
                return (React.createElement("div", { key: index, onClick: (e) => {
                        e.stopPropagation();
                        updateSegmentDeviceListKeyPath(keyPathOption);
                        this.updatePopoverVisibility();
                    }, style: {
                        display: 'flex',
                        height: device !== 'Mobile' ? 55 : 71,
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement("div", { style: {
                            flexGrow: 1,
                            marginLeft: 8,
                        } },
                        React.createElement(src_1.Text, { text: keyPathOption, size: "large" })),
                    React.createElement(src_1.RadioButton, { selected: keyPathOption === keyPath, style: {
                            outerStyle: { height: 18, width: 18 },
                        } })));
            }))));
    }
    onChange(e) {
        this.props.uploadDeviceList(e.target.files[0]);
    }
    render() {
        const { segment: { keyPath }, device, isDeviceListUploading, isSegmentSizeUpdating, segmentSize, segment, updateSegmentDeviceList, updateActivePopover, } = this.props;
        if (segment.deviceList.id) {
            const { name, size, createdAt } = segment.deviceList;
            const sizeAndCreatedAtCopy = `${size.toLocaleString()} row${size > 1 ? 's' : ''} ${String.fromCharCode(183)} Created ${new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
            return (React.createElement(React.Fragment, null,
                this.renderIdentifierSelector(),
                React.createElement(Row_1.default, null,
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'flex-start',
                        } },
                        React.createElement(src_1.Text, { text: name, size: "large" }),
                        React.createElement(src_1.Text, { text: sizeAndCreatedAtCopy, size: "small", textStyle: { color: src_1.steel } })),
                    React.createElement(src_1.CircleCloseIcon, { fill: src_1.turquoise, onClick: () => updateSegmentDeviceList('') })),
                React.createElement("div", { style: { textAlign: 'right', marginTop: '24px' } }, isSegmentSizeUpdating ? (React.createElement(LoadingIndicator_1.default, null)) : (React.createElement(src_1.Text, { size: "small", text: `${segmentSize} device${segmentSize !== 1 ? 's' : ''}`, textStyle: { color: src_1.steel } })))));
        }
        if (isDeviceListUploading) {
            return (React.createElement(React.Fragment, null,
                this.renderIdentifierSelector(),
                React.createElement(Row_1.default, null,
                    React.createElement(LoadingIndicator_1.default, null))));
        }
        return (React.createElement(React.Fragment, null,
            this.renderIdentifierSelector(),
            React.createElement(Row_1.default, null,
                React.createElement("label", { htmlFor: "list-upload", style: {
                        height: 48,
                        width: 'calc(100% - 22px)',
                        display: 'flex',
                        alignItems: 'center',
                        flex: '1 1 auto',
                    } },
                    React.createElement(src_1.Button, { text: "Upload List", type: "primary", size: "large", style: {
                            outerStyle: {
                                pointerEvents: 'none',
                                flex: '0 0 auto',
                            },
                        } }),
                    React.createElement(src_1.Text, { size: "small", text: `Text or CSV file containing a list of Identifiers`, textStyle: {
                            color: src_1.steel,
                            marginLeft: 16,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: '1 1 auto',
                        } }),
                    React.createElement("input", { accept: ".csv,.txt", id: "list-upload", onChange: (e) => this.onChange(e), type: "file", style: { visibility: 'hidden', width: 0, height: 0 } })),
                React.createElement(DeviceListSelectorModal_1.default, { device: device },
                    React.createElement(src_1.FileSelectIcon, { fill: src_1.turquoise, onClick: () => updateActivePopover('device-list-selector-modal') })))));
    }
}
const mapStateToProps = (state) => {
    const segment = reducers_1.getEditableCampaignSegment(state);
    const settings = reducers_1.getSettings(state);
    return {
        activePopover: reducers_1.getActivePopover(state),
        isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
        isDeviceListUploading: reducers_1.getIsDeviceListUploading(state),
        isSegmentSizeUpdating: reducers_1.getIsSegmentSizeUpdating(state),
        segmentSize: reducers_1.getSegmentSize(state),
        segment,
        deviceListKeyPaths: settings ? settings.keyPaths : [],
    };
};
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateSegmentDeviceList: (id, name, size, createdAt) => dispatch(actions_1.updateSegmentDeviceList(id, name, size, createdAt)),
    updateSegmentDeviceListKeyPath: (keyPath) => dispatch(actions_1.updateSegmentDeviceListKeyPath(keyPath)),
    updateActivePopover: (popover) => dispatch(actions_1.updateActivePopover(popover)),
    uploadDeviceList: (file) => dispatch(actions_1.uploadDeviceList(file)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DeviceListSelector);
